// atorhome — toggles for the product info custom_liquid blocks (markup lives in templates/product.json):
// description "Read more" (.pd-btn), details accordion (.acd-btn), delivery card (.ojc-head),
// rating review count (.ah-rating__count) → smooth scroll to the testimonials section (#reviews).
(function () {
  if (window.atorhomeProductUi) return;
  window.atorhomeProductUi = true;

  function toggle(container, button) {
    const open = !container.classList.contains('open');
    container.classList.toggle('open', open);
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    return open;
  }

  document.addEventListener('click', (event) => {
    const readMore = event.target.closest('.pd-btn');
    if (readMore) {
      const wrap = readMore.closest('.pd-wrap');
      const open = readMore.getAttribute('aria-expanded') !== 'true';
      wrap.querySelector('.pd-full').hidden = !open;
      wrap.querySelector('.pd-short').hidden = open;
      readMore.setAttribute('aria-expanded', open ? 'true' : 'false');
      readMore.classList.toggle('open', open);
      readMore.querySelector('span').textContent = open
        ? readMore.dataset.less || 'Show less'
        : readMore.dataset.more || 'Read more';
      return;
    }

    const accordion = event.target.closest('.acd-btn');
    if (accordion) {
      const item = accordion.closest('.acd-item');
      const body = item.querySelector('.acd-body');
      // Size to the content so long sections (e.g. Specifications) aren't cut off by the CSS max-height.
      body.style.maxHeight = toggle(item, accordion) ? body.scrollHeight + 'px' : '';
      return;
    }

    const reviewsLink = event.target.closest('.ah-rating__count');
    if (reviewsLink) {
      const reviews = document.getElementById('reviews');
      if (!reviews) return;
      event.preventDefault();
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      reviews.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      reviews.querySelector('.testimonials-heading')?.focus({ preventScroll: true });
      return;
    }

    const journey = event.target.closest('.ojc-head');
    if (journey) toggle(journey.closest('.ojc'), journey);
  });
})();
